export const subjectOfRF = 'Ростовская область'
